/**
 * 送客導線と自社広告の設定（TK-018、FR-018 / FR-022、ADR-013）。
 *
 * 内容は `promo.config.json` で制御する（URL・ラベル・表示有無・広告文言）。設定は
 * ビルド時にバンドルへ畳み込まれ、ランタイムのフェッチは発生しない（FR-022
 * 「表示のたびに追加のネットワーク往復が発生しない」）。掲載できるのは静的な
 * テキストとリンクのみで、第三者スクリプト・トラッカー・iframe は構造的に持ち込めない
 * （`06-api-design.md` の CSP `script-src 'self'` / `frame-ancestors 'none'` も維持される）。
 */

import config from './promo.config.json';

/** クリア後の送客導線（FR-018）。 */
export interface OutboundConfig {
  readonly enabled: boolean;
  /** 送客先。既定は姉妹サイト https://novel.r18hakadoru.ai/ */
  readonly url: string;
  readonly label: string;
}

/** ステージ遷移時の自社広告インタースティシャル（FR-022）。 */
export interface InterstitialConfig {
  readonly enabled: boolean;
  /** 広告のリンク先。 */
  readonly url: string;
  readonly headline: string;
  /** 補足文。省略可。 */
  readonly body?: string;
  /** 広告リンクのラベル。 */
  readonly linkLabel: string;
}

/**
 * 運営元の X アカウントへの導線（TK-070、ADR-013）。クリア後の下部導線帯と、選択画面・
 * 404 のフッターに、年齢認証の成立後にだけ JS で置く（`shell/social.ts`）。
 */
export interface SocialConfig {
  readonly enabled: boolean;
  /** アカウントの URL。既定は https://x.com/asalabo_r18 */
  readonly url: string;
  /** リンクの文言。下部導線帯では文言はこれだけになる。 */
  readonly label: string;
  /** フォローする理由を示す前置き。フッターでは本文として、導線帯では title として出す。 */
  readonly lead: string;
}

export interface PromoConfig {
  readonly outbound: OutboundConfig;
  readonly interstitial: InterstitialConfig;
  readonly social: SocialConfig;
}

/** 設定の実体。型はこの代入で検査される（値の出所は promo.config.json のみ）。 */
export const PROMO: PromoConfig = config;

/** クリック判定に使う最小面。`MouseEvent` はこれを構造的に満たす。 */
export interface ActivationLike {
  readonly button: number;
  readonly ctrlKey: boolean;
  readonly metaKey: boolean;
  readonly shiftKey: boolean;
  readonly altKey: boolean;
}

/**
 * 「そのタブで普通に開く」クリックか。
 *
 * 修飾キー付き・中ボタンのクリック（新しいタブで開く等）はブラウザ既定の挙動に委ね、
 * インタースティシャルで横取りしない。導線を塞がないための規則（FR-022）で、
 * ここを純関数に切り出してユニットテストで固定する。
 */
export function isPlainActivation(event: ActivationLike): boolean {
  return event.button === 0 && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey;
}
